import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
// import ReactGA from 'react-ga';
import Navbar from '../components/Navbar/Navbar';
import Home from '../screens/Home/Home';
import Contacts from '../screens/Contacts/Contacts';
// import CallForSpeakers from '../screens/CallForSpeakers/CallForSpeakers';
import SpeakersContainer from '../screens/Speakers/Speakers';
import SpeakerDetailsContainer from '../screens/SpeakerDetails/SpeakerDetails';
import ProgramContainer from '../screens/Program/Program';
import TalkDetailContainer from '../screens/TalkDetail/TalkDetail';
import LocationMap from '../screens/LocationMap/LocationMap';
// import Livestream from '../screens/Livestream/Livestream';
// import FeedbackForm from '../screens/FeedbackForm/FeedbackForm';

export const Routes = () => {
  // const location = useLocation();

  // useEffect(() => {
  //   if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
  //     ReactGA.initialize('UA-178637127-1');
  //     ReactGA.set({ anonymizeIp: true });
  //     ReactGA.pageview(location.pathname + location.search);
  //   }
  // }, [location]);

  return (
    <Route>
      <Navbar />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Contacts} exact path="/contacts" />
        {/* <Route component={CallForSpeakers} exact path="/cfs" /> */}
        <Route component={LocationMap} exact path="/location-map" />
        <Route component={SpeakersContainer} exact path="/speakers" />
        <Route component={SpeakerDetailsContainer} exact path="/speakers/:speakerId" />
        <Route component={ProgramContainer} exact path="/program" />
        <Route component={TalkDetailContainer} exact path="/program/:talkId" />
        {/* <Route component={Livestream} exact path="/livestream" /> */}
        <Route component={ProgramContainer} exact path="/workshops" />
        <Route exact path="/workshops/1">
          <Redirect to="/program/60bcd045-527c-40fc-86b5-1fff96f1542e" />
        </Route>
        <Route exact path="/workshops/2">
          <Redirect to="/program/90ea097a-1f30-4c77-8f09-f2efe7b5fc63" />
        </Route>
        <Route exact path="/workshops/3">
          <Redirect to="/program/031f8a36-d906-4981-a03c-3c5e7f6b71ed" />
        </Route>
        <Route exact path="/workshops/4">
          <Redirect to="/program/773480f2-8509-4953-970e-bf23e444f240" />
        </Route>
        <Route exact path="/workshops/5">
          <Redirect to="/program/1aca1163-b66e-45a4-ae5d-c61403427c46" />
        </Route>
        <Route exact path="/workshops/6">
          <Redirect to="/program/2e80a664-3082-4ee6-8bc4-ffcc91ec0383" />
        </Route>
        <Route exact path="/workshops/7">
          <Redirect to="/program/762d4550-35cb-470a-ba8c-b71c3c09c537" />
        </Route>
        <Route exact path="/workshops/8">
          <Redirect to="/program/70f69c68-8d02-4399-8a15-35b74dc4a4a7" />
        </Route>
        <Route exact path="/workshops/9">
          <Redirect to="/program/3c0cab80-3735-4c51-b781-a1b45645e31e" />
        </Route>
        <Route exact path="/workshops/10">
          <Redirect to="/program/2b64bc95-4e61-44bd-b4d9-55e6b10f68e1" />
        </Route>
        <Route exact path="/workshops/11">
          <Redirect to="/program/b0b4e781-a0ba-47d4-b69d-7e3aee568e42" />
        </Route>
        <Route exact path="/workshops/12">
          <Redirect to="/program/c8ca230d-3164-436a-abb7-ccfeb8284fc7" />
        </Route>
        <Route exact path="/workshops/13">
          <Redirect to="/program/81deeef0-b68a-4ed5-bfc3-d95a31be0ae1" />
        </Route>
        {/* <Route component={FeedbackForm} exact path="/ff" /> */}
      </Switch>
    </Route>
  );
};

const RouterContainer = props => (
  <Router {...props}>
    <Routes />
  </Router>
);

export default RouterContainer;
